import {CommonModule} from '@angular/common';
import {NgModule} from '@angular/core';
import {AppBarModule} from '@app/presentation/components/app-bar/app-bar.module';
import {ProductListModule} from '@app/presentation/components/product-list/product-list.module';
import {SimilarProductsModule} from '@app/presentation/components/similar-products/similar-products.module';
import {TranslateModule} from '@ngx-translate/core';
import {AngularSvgIconModule} from 'angular-svg-icon';
import {NoStockBottomSheetComponent} from './no-stock-bottom-sheet/no-stock-bottom-sheet.component';
import {NoStockModalComponent} from './no-stock-modal/no-stock-modal.component';
import {NoStockServiceViewModel} from './no-stock-service.view-model';
import {NoStockService} from './no-stock.service';
import {ButtonModule} from "@app/presentation/components/button/button.module";
import {LocalizeRouterModule} from "@gilsdav/ngx-translate-router";
import {RouterModule} from "@angular/router";
import {
    ProductPortraitTileSkeletonModule
} from "@app/presentation/components/product-portrait-tile-skeleton/product-portrait-tile-skeleton.module";


@NgModule({
  declarations: [
    NoStockBottomSheetComponent,
    NoStockModalComponent
  ],
    imports: [
        CommonModule,
        AppBarModule,
        AngularSvgIconModule,
        TranslateModule,
        ProductListModule,
        SimilarProductsModule,
        ButtonModule,
        LocalizeRouterModule,
        RouterModule,
        ProductPortraitTileSkeletonModule
    ],
  providers: [
    NoStockService,
    NoStockServiceViewModel
  ]
})
export class NoStockServiceModule { }
